{
  "en": {
    "contact": {
      "actions": {
        "accept": "Ok",
        "add": "Add Contact",
        "add_type": "Add {type}",
        "backInspirationLists": "Back to Inspiration Lists",
        "cancelNew": "Undo",
        "deleteCustomer": "Delete Customer...",
        "deleteEmployee": "Delete Team Member...",
        "deleteLead": "Delete Lead...",
        "deletePartner": "Delete Partner...",
        "edit": "Edit",
        "impersonate": "Impersonate",
        "impersonateStart": "Step through the orange portal to explore the world of {name}.",
        "impersonateStop": "Go back to your world",
        "invite": "Send invitation",
        "newTicket": "New Conversation",
        "resendInvitationEmail": "Resend invitation email",
        "searchContact": "Search Contact",
        "searchCustomer": "Search Customer",
        "searchEmployee": "Search Team Member",
        "selectAll": "Select all {total} contacts",
        "selectOption": "Select option",
        "setProfilePicture": "Set profile picture",
        "showall": "Show all",
        "unSelectAll": "Clear selection."
      },
      "attributes": {
        "language": "Language",
        "timezone": "Timezone",
        "title": "Title"
      },
      "labels": {
        "address": "Address",
        "all": "All contacts",
        "back_to_overview": "Back to overview",
        "cannot_create_role": "Reach out to an owner to create a new contact",
        "company": "Organisation",
        "company_all": "Every Organisation",
        "contact_status": {
          "active": "Active",
          "added": "Not invited yet",
          "all": "Every status",
          "blocked": "Deactivated",
          "invited": "Invited",
          "status": "Status"
        },
        "contact_type": "Type",
        "customer": "Customer",
        "customers": "Customers",
        "employee": "Team",
        "export_contacts": "Export contacts",
        "general": "General",
        "impersonateInactiveProfile": "This awesome person is not active yet. Please activate the customer first.",
        "invite": "Yes, invite contacts",
        "inviteProfileFirstCustomer": "Invite customer to platform first in order to send message, impersonate or resend invitation email",
        "inviteProfileFirstPartner": "Invite partner to platform first in order to impersonate or resend invitation email",
        "last_login": "Last login",
        "last_seen": "last seen",
        "last_seen_not_seen_yet": "no login yet",
        "lead": "Lead",
        "name": "Name",
        "name_or_email_address": "Name or email address",
        "name_or_email_address_phone": "Name, email address or phone",
        "noContacts": "No Contacts",
        "no_contacts": "No contacts to export",
        "no_contacts_results": "This search does not have any results. Try out other filters to find the right person.",
        "no_contacts_results_subtitle": "This search does not have any results. Try out other filters to find the right person.",
        "no_contacts_results_title": "No contacts found",
        "number_contacts": "No contacts | 1 contact | {count} contacts",
        "other": "Other",
        "partner": "Partner",
        "partners": "Partners",
        "project": "Project",
        "secondary_contact": "Secondary Contact",
        "selectOne": "Select at least 1 contact",
        "selectProjectForImpersonation": "For which project do you want to impersonate {customer_name}?",
        "selected": "{selected} contact selected. | {selected} contacts selected.",
        "sorting": {
          "last_name": "Name",
          "session_started_at": "Last login",
          "status": "Status"
        },
        "totalSelected": "All {total} contacts are selected.",
        "units": "Units"
      },
      "navigation": {
        "backToContacts": "Back to contacts"
      },
      "placeholders": {
        "byNameOrEmailAddress": "By name or email address"
      },
      "validation": {
        "emailTaken": "Email address is the same as the previous one",
        "mustBeEmailAddress": "Valid email address required",
        "requireEmailAddress": "Email required"
      }
    }
  }
}
